import React, { useEffect } from 'react';
import DOMPurify from 'dompurify';
import PropTypes from 'prop-types';

import { useStaticBlock } from '@atlas/core';
import { Loader } from '@atlas/ui';

const CasinoStaticBlock = ({ className = '', name, setIsFullWidth }) => {
  const { content, error, loading } = useStaticBlock(name);

  useEffect(() => {
    if (content) {
      setIsFullWidth(true);
    }
  }, [content, error, setIsFullWidth]);

  if (loading)
    return (
      <div>
        <Loader />
      </div>
    );

  if (!content || error) return null;

  return (
    <div className="static">
      <div
        className={className}
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(content, {
            ADD_ATTR: ['target'],
            KEEP_CONTENT: true,
          }),
        }}
      />
    </div>
  );
};

CasinoStaticBlock.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  setIsFullWidth: PropTypes.func,
};

export default React.memo(CasinoStaticBlock);
